import { defineComponent as _defineComponent } from 'vue'
import { Skeleton, Spin, Empty } from 'ant-design-vue'
import { useRouter } from '@/hooks/useRouter'
import useList from '@/hooks/useList'
import { getHotList } from '@/api/notice'
import dayjs from 'dayjs'
import { toDetail } from '@/utils'
import useInit from '@/hooks/useInit'

type Props = {
  /** 标题 */
  title?: string
  /** 点击标题时跳转的地址 */
  target?: string
  /** 列表所查询的`noticeTag` */
  noticeTags: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HotList',
  props: {
    title: { default: '热点' },
    target: null,
    noticeTags: null
  },
  setup(__props: any) {

const props = __props as { title: string, target?: string, noticeTags: string };

const router = useRouter()



const { dataList, loading, pagination, onQueryList } = useList<NoticeItem>({
  getList: getHotList,
  formatGetListQuery(query) {
    return {
      ...query,
      noticeTags: props.noticeTags,
    }
  },
})

const { loading: skeletonLoading } = useInit(dataList)

function onClickHead() {
  if (props.target) {
    router?.push(props.target)
  }
}

function onClick(item: NoticeItem) {
  toDetail(item)
}

return { __sfc: true,router, props, dataList, loading, pagination, onQueryList, skeletonLoading, onClickHead, onClick, Skeleton, Spin, Empty, dayjs }
}

})